import React from 'react';
import PropTypes from 'prop-types';
/**
 * The component which renders field metadata markup
 * @param {FieldMetadataProps} props the props of the component
 * @returns metadata markup wrapped around children
 */
export const FieldMetadata = (props) => {
    const data = JSON.stringify(props.metadata);
    const attributes = {
        type: 'text/sitecore',
        chrometype: 'field',
        className: 'scpm',
    };
    const codeOpenAttributes = Object.assign(Object.assign({}, attributes), { kind: 'open' });
    const codeCloseAttributes = Object.assign(Object.assign({}, attributes), { kind: 'close' });
    return (React.createElement(React.Fragment, null,
        React.createElement("code", Object.assign({}, codeOpenAttributes), data),
        props.children,
        React.createElement("code", Object.assign({}, codeCloseAttributes))));
};
FieldMetadata.displayName = 'FieldMetadata';
FieldMetadata.propTypes = {
    metadata: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};
